import { createTheme } from '@mui/material';
import * as locales from '@mui/material/locale';
import * as dateLocales from '@mui/x-date-pickers/locales';
import { useMemo } from 'react';
import useMarket from 'stores/useMarket';
import mkTheme from 'styles/theme/mkTheme';

export default function useThemeWithLocale() {
    const { dateMuiLocale, muiLocale } = useMarket((state) => ({
        muiLocale: state.muiLocale,
        dateMuiLocale: state.dateMuiLocale,
    }));

    const themeWithLocale = useMemo(() => createTheme(
        mkTheme,
        locales[muiLocale],
        dateLocales[dateMuiLocale],
    ), [dateMuiLocale, muiLocale]);

    return themeWithLocale;
}
